export const CUSTOM_INITIAL_STATE = {
    chatExport:{
        byChatId: {

        }
    }
}